export default "__VITE_ASSET__CmM9QDDX__"